import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { SHOW_INFO, CONTACT_INFO } from '../data/showData';

const Termini = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#0a0a0a]">
      <div className="container-custom max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-gray-400 hover:text-[#FFD700] transition-colors mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla home
        </Link>

        <div className="bg-[#121212] rounded-2xl border border-white/5 p-6 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <FileText className="w-8 h-8 text-[#25D366]" />
            <h1 className="text-3xl md:text-4xl font-bold text-white">Termini e Condizioni</h1>
          </div>

          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <p className="text-gray-400 text-sm">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Oggetto</h2>
              <p>
                I presenti Termini e Condizioni regolano l'acquisto dei biglietti per lo 
                spettacolo "{SHOW_INFO.title} - {SHOW_INFO.subtitle}" organizzato da {SHOW_INFO.organization}.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Prenotazione e acquisto</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>La prenotazione avviene tramite contatto WhatsApp al numero {CONTACT_INFO.whatsappDisplay}</li>
                <li>Il prezzo del biglietto è di {SHOW_INFO.ticketPrice}€ a persona</li>
                <li>La prenotazione è confermata solo dopo il ricevimento del pagamento</li>
                <li>I metodi di pagamento accettati sono: Satispay, PayPal, Bonifico bancario</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Assegnazione posti</h2>
              <p>
                I posti vengono assegnati in base all'ordine di prenotazione e pagamento. 
                Prima prenoti e paghi, migliore sarà la posizione assegnata. 
                L'assegnazione definitiva dei posti avviene dopo la conferma del pagamento.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Biglietto regalo</h2>
              <p>
                È possibile acquistare biglietti regalo personalizzati. Il biglietto regalo 
                includerà il nome del destinatario e, se richiesto, un messaggio personalizzato. 
                La personalizzazione è inclusa nel prezzo del biglietto.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Cambio nominativo</h2>
              <p>
                Il cambio nominativo del biglietto è possibile fino a 48 ore prima della data 
                dello spettacolo. Per richiedere un cambio nominativo, contattare via WhatsApp 
                o email fornendo i dati del nuovo intestatario.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Rimborsi</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Le richieste di rimborso devono pervenire almeno 7 giorni prima della data dello spettacolo</li>
                <li>Ogni richiesta sarà valutata caso per caso</li>
                <li>In caso di cancellazione dello spettacolo da parte dell'organizzazione, sarà garantito il rimborso integrale o la possibilità di utilizzare il biglietto per una data alternativa</li>
                <li>Non sono previsti rimborsi per mancata partecipazione senza preavviso</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Comportamento durante lo spettacolo</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Si richiede di arrivare almeno 20 minuti prima dell'inizio</li>
                <li>Lo spettacolo inizia puntualmente alle ore 21:00</li>
                <li>È vietato registrare video o audio durante lo spettacolo</li>
                <li>I telefoni cellulari devono essere silenziati</li>
                <li>L'organizzazione si riserva il diritto di allontanare chiunque disturbi lo svolgimento dello spettacolo</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Servizi del teatro</h2>
              <p>
                Il {SHOW_INFO.venue.name} dispone di un bar interno aperto prima dello spettacolo 
                e durante l'intervallo. Il teatro è accessibile alle persone con mobilità ridotta; 
                per esigenze specifiche, contattare l'organizzazione in anticipo.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">9. Responsabilità</h2>
              <p>
                L'organizzazione non è responsabile per eventuali furti o smarrimenti di oggetti 
                personali all'interno del teatro. Si declina ogni responsabilità per danni diretti 
                o indiretti derivanti dalla partecipazione allo spettacolo.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">10. Modifiche</h2>
              <p>
                L'organizzazione si riserva il diritto di modificare data, orario o location 
                dello spettacolo per cause di forza maggiore. In tal caso, gli acquirenti 
                saranno tempestivamente informati e potranno richiedere il rimborso.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">11. Contatti</h2>
              <p>Per qualsiasi domanda o chiarimento:</p>
              <ul className="list-none space-y-2 mt-4">
                <li>WhatsApp: {CONTACT_INFO.whatsappDisplay}</li>
                <li>Email: {CONTACT_INFO.email}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">12. Foro competente</h2>
              <p>
                Per qualsiasi controversia relativa ai presenti Termini e Condizioni, sarà 
                competente il Foro di Torino.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Termini;
